import Dexie from 'dexie';

const db = new Dexie('SyncData');
db.version(1).stores({
  tabs: 'id, parentId',
  device_windows: 'id, parentId',
  history: 'id, visited',
});

db.version(2).stores({
  devices: 'id, platform',
});

db.version(3).stores({
  preferences: 'id',
});

db.version(4).stores({
  passwords: 'id',
});

db.version(5).stores({
  bookmarks: 'id, type, folder, [parent+folder]',
});

export default db;
